import React from "react";
import { Error } from "../components";
import { envStaticHost } from "../Utils/windowHelper";
import { RootState } from "../State/store";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { translate } from "../Utils/language";

const UnauthorizedRoute = () => {
  const { language, facts } = useSelector((state: RootState) => ({
    language: state.facts.language,
    facts: state.facts,
  }));

  return (
    <Wrapper>
      <Error
        errorImage={`${envStaticHost}/static/${facts?.referer}/error/Error_1.png`}
        headerText={translate(language, "this link has expired")}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export default UnauthorizedRoute;
